module.exports = __webpack_public_path__ + "static/background-0ab58076773c2aac62ed81b9f1d9cbbe.jpg";